import React from "react"
//import {Linking} from 'react-native'
import PCQACL from "../images/pcqacl.webp"
import PHA from "../images/pha.webp"
import PHILHEALTH from "../images/philhealth.webp"
import DOH from "../images/doh.webp"

export default function Footer(){

  return(
    <div className="footer">
      <div className="footer--info">
        <div className="footer--contact">
          {/* <div className="footer--title">Patient's Portal</div> */}
          <h2 className="footer--title">Contact Us</h2>
          <a href="https://www.facebook.com/QRDiagnostics.Tac" target="_blank" className="footer--text link" rel="noreferrer">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="#ffffff" style={{marginRight:"5px"}}><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            <span className="underline">
            fb.com/QRDiagnostics.Tac
            </span>

        </a>
          <a href="tel:+639998886694" className="footer--text link">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" style={{marginRight:"5px"}}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              0999 888 6694
          </a>
          
        </div>
        <div className="footer--location">
          <h2 className="footer--title">Location</h2>
          <a className="link" href="https://goo.gl/maps/2RsCE3j2qVv513Ws6" target = "_blank" rel="noreferrer">
            <p className="footer--text link">Unit A, M Block Building, Barangay 77, Marasbaras 6500 Tacloban City, Philippines</p>
          </a>
          <div className="footer__section" style={{marginTop: "1rem"}}>
              <h2 className="footer--title">Useful Links</h2>
              <a href="https://patient.qrdiagnosticsph.com" target="_blank" rel="noopener noreferrer">Patient Portal</a>
              <a style={{margin: "0 1rem"}} href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
          </div>
        </div>
        <div className="footer--licensed">
          <h2 className="footer--title">Licensed or accredited by:</h2>
         <div className="footer--pictures">
            <img src={PCQACL} alt="PCQACL Logo" width="52" height="52" style={{objectFit: "contain"}} />
            <img src={PHA} alt="PHA Logo" width="52" height="52" style={{objectFit: "contain"}} />
            <img src={PHILHEALTH} alt="PhilHealth" width="110" height="52" style={{objectFit: "contain"}} />
            <img src={DOH} alt="DOH Logo" width="52" height="52" style={{objectFit: "contain"}} />
        </div>

        </div>
      </div>
      <div className="footer--copyright">
        <p>
          ©2022 Quest & Reliance Diagnostics. All Rights Reserved.
        </p>
      </div>
    </div>
  )
}